// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Pagination,
//   TextField,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Card,
//   CardContent,
//   CardHeader,
//   IconButton,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
// import SearchIcon from "@mui/icons-material/Search";
// import { saveAs } from "file-saver";
// import * as XLSX from "xlsx";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable";
// import axios from "axios";
// import swal from "sweetalert";
 
// const StyledTableCell = styled(TableCell)({
//   padding: "16px",
//   fontSize: "0.875rem",
//   color: "#4A4A4A",
// });
 
// const ITEMS_PER_PAGE = 5;
 
// const Review = () => {
//   const [page, setPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [data, setData] = useState([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [currentIdeaId, setCurrentIdeaId] = useState(null);
//   const [message, setMessage] = useState("");
//   const [amountRange, setAmountRange] = useState("");
 
//   const fetchParticipants = async () => {
//     try {
//       swal({
//         title: "Loading...",
//         text: "Fetching projects, please wait.",
//         icon: "info",
//         buttons: false,
//         closeOnClickOutside: false,
//       });
 
//       const response = await axios.get(
//         "https://newbackend.elephant-tank.com/api/get_idea_submission/"
//       );
 
//       const fetchedData = response.data.map((item) => ({
//         id: item.id,
//         title: item.title,
//         description: item.description,
//         projectType: item.project_type || "N/A",
//         aiScore: item.ai_score || "N/A",
//         submissionDate: item.created_at,
//         isSingleSubmission: item.is_single_sub ? "Yes" : "No",
//         idea: item.idea || null,
//         ppt: item.ppt || null,
//         video_file: item.video_file || null,
//         qrCode: item.qr_code_details?.[0]?.qr_code || null,
//         studentDetails: item.stud_id || {},
//       }));
 
//       swal.close();
//       setData(fetchedData);
//     } catch (error) {
//       swal("Error", "Failed to fetch projects. Please try again later.", "error");
//       console.error("Error fetching participants:", error);
//     }
//   };
 
//   useEffect(() => {
//     fetchParticipants();
//   }, []);
 
//   const handleDownloadQR = (qrCode, title) => {
//     const link = document.createElement("a");
//     link.href = `data:image/png;base64,${qrCode}`;
//     link.download = `${title.replace(/\s+/g, "_")}_QR_Code.png`;
//     link.click();
//   };
 
//   const openMessageDialog = (ideaId) => {
//     setCurrentIdeaId(ideaId);
//     setOpenDialog(true);
//   };
 
//   const handleDialogClose = () => {
//     setOpenDialog(false);
//     setMessage("");
//     setAmountRange("");
//   };
 
//   const handleSubmitMessage = async () => {
//     if (!message || !amountRange) {
//       swal("Error", "Message and amount range are required.", "error");
//       return;
//     }
 
//     const payload = {
//       investor_id: localStorage.getItem("user_id"),
//       idea_id: currentIdeaId,
//       message: message,
//       amount_range: amountRange,
//     };
 
//     try {
//       swal({
//         title: "Submitting...",
//         text: "Please wait while we submit your message.",
//         icon: "info",
//         buttons: false,
//         closeOnClickOutside: false,
//       });
 
//       const response = await axios.post(
//         "https://elephant-eks.tdtlworld.com/api/show_interest/",
//         payload
//       );
 
//       if (response.data && response.data.msg) {
//         swal("Success", response.data.msg, "success");
//       }
 
//       setOpenDialog(false);
//       setMessage("");
//       setAmountRange("");
//       fetchParticipants();
//     } catch (error) {
//       swal("Error", "You have already shown interest in this project.", "error");
//       console.error("Error submitting message:", error);
//     }
//   };
 
//   const handleChangePage = (event, newPage) => setPage(newPage);
 
//   const filteredData = data.filter((row) =>
//     (row.title || "").toLowerCase().includes(searchTerm.toLowerCase())
//   );
 
//   const paginatedData = filteredData.slice(
//     (page - 1) * ITEMS_PER_PAGE,
//     page * ITEMS_PER_PAGE
//   );
//   const exportToExcel = () => {
//     const formattedData = data.map((item, index) => ({
//       "Sr. No.": index + 1,
//       "Project Title": item.title,
//       "Student Name": item.studentDetails.full_name || "N/A",
//       Institution: item.studentDetails.institution || "N/A",
//       "Project Type": item.projectType,
//       "AI Score": item.aiScore,
//       "Idea File": item.idea ? "Click to View PDF" : "No File",
//       "PPT File": item.ppt ? "Click to View PPT" : "No File",
//       "Video File": item.video_file ? "Click to View Video" : "No File",
//       "QR Code": item.qrCode ? "Click to View QR Code" : "No QR Code",
//     }));
 
//     const worksheet = XLSX.utils.json_to_sheet(formattedData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
//     XLSX.writeFile(workbook, "Projects.xlsx");
//   };
 
// //   const exportToExcel = () => {
// //     const formattedData = data.map((item, index) => ({
// //       "Sr. No.": index + 1,
// //       "Project Title": item.title,
// //       "Student Name": item.studentDetails.full_name || "N/A",
// //       Institution: item.studentDetails.institution || "N/A",
// //       "Project Type": item.projectType,
// //       "AI Score": item.aiScore,
// //       "Idea File": item.idea
// //         ? `=HYPERLINK("${item.idea}", "View PDF")`
// //         : "No File",
// //       "PPT File": item.ppt
// //         ? `=HYPERLINK("${item.ppt}", "View PPT")`
// //         : "No File",
// //       "Video File": item.video_file
// //         ? `=HYPERLINK("${item.video_file}", "View Video")`
// //         : "No File",
// //       "QR Code": item.qrCode
// //         ? `=HYPERLINK("data:image/png;base64,${item.qrCode}", "View QR Code")`
// //         : "No QR Code",
// //     }));
 
// //     const worksheet = XLSX.utils.json_to_sheet(formattedData);
// //     const workbook = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
// //     XLSX.writeFile(workbook, "Projects.xlsx");
// //   };
 
// //   const exportToExcel = () => {
// //     const formattedData = data.map((item, index) => ({
// //       "Sr. No.": index + 1,
// //       "Project Title": item.title,
// //       "Student Name": item.studentDetails.full_name || "N/A",
// //       Institution: item.studentDetails.institution || "N/A",
// //       "Project Type": item.projectType,
// //       "AI Score": item.aiScore,
// //       "Idea File": item.idea ? `=HYPERLINK("${item.idea}", "View PDF")` : "No File",
// //       "PPT File": item.ppt ? `=HYPERLINK("${item.ppt}", "View PPT")` : "No File",
// //       "Video File": item.video_file
// //         ? `=HYPERLINK("${item.video_file}", "View Video")`
// //         : "No File",
// //       "QR Code": item.qrCode
// //         ? `=HYPERLINK("data:image/png;base64,${item.qrCode}", "View QR Code")`
// //         : "No QR Code",
// //     }));
 
// //     const worksheet = XLSX.utils.json_to_sheet(formattedData);
// //     const workbook = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
// //     XLSX.writeFile(workbook, "Projects.xlsx");
// //   };
 
// //   const exportToExcel = () => {
// //     const formattedData = data.map((item) => ({
// //       "Sr. No.": data.indexOf(item) + 1,
// //       "Project Title": item.title,
// //       "Student Name": item.studentDetails.full_name || "N/A",
// //       Institution: item.studentDetails.institution || "N/A",
// //       "Project Type": item.projectType,
// //       "AI Score": item.aiScore,
// //       "Idea File": item.idea ? `=HYPERLINK("${item.idea}", "View File")` : "No File",
// //       "PPT File": item.ppt ? `=HYPERLINK("${item.ppt}", "View File")` : "No File",
// //       "Video File": item.video_file
// //         ? `=HYPERLINK("${item.video_file}", "Watch Video")`
// //         : "No File",
// //       "QR Code": item.qrCode
// //         ? `=HYPERLINK("data:image/png;base64,${item.qrCode}", "View QR Code")`
// //         : "No QR Code",
// //     }));
 
// //     const worksheet = XLSX.utils.json_to_sheet(formattedData);
// //     const workbook = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
// //     XLSX.writeFile(workbook, "Projects.xlsx");
// //   };
 
// // const exportToExcel = () => {
// //     const formattedData = data.map((item, index) => ({
// //       "Sr. No.": index + 1,
// //       "Project Title": item.title,
// //       "Student Name": item.studentDetails.full_name || "N/A",
// //       Institution: item.studentDetails.institution || "N/A",
// //       "Project Type": item.projectType,
// //       "AI Score": item.aiScore,
// //       "Idea File": item.idea ? `=HYPERLINK("${item.idea}", "View File")` : "No File",
// //       "PPT File": item.ppt ? `=HYPERLINK("${item.ppt}", "View File")` : "No File",
// //       "Video File": item.video_file
// //         ? `=HYPERLINK("${item.video_file}", "Watch Video")`
// //         : "No File",
// //       "QR Code": item.qrCode
// //         ? `=HYPERLINK("data:image/png;base64,${item.qrCode}", "View QR Code")`
// //         : "No QR Code",
// //     }));
 
// //     const worksheet = XLSX.utils.json_to_sheet(formattedData);
// //     const workbook = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
// //     XLSX.writeFile(workbook, "Projects.xlsx");
// //   };
 
// // const exportToExcel = () => {
// //     const formattedData = data.map((item, index) => ({
// //       "Sr. No.": index + 1,
// //       "Project Title": item.title,
// //       "Student Name": item.studentDetails.full_name || "N/A",
// //       Institution: item.studentDetails.institution || "N/A",
// //       "Project Type": item.projectType,
// //       "AI Score": item.aiScore,
// //       "Idea File": item.idea ? "View PDF" : "No File",
// //       "PPT File": item.ppt ? "View PPT" : "No File",
// //       "Video File": item.video_file ? "View Video" : "No File",
// //       "QR Code": item.qrCode ? "View QR Code" : "No QR Code",
// //     }));
 
// //     const worksheet = XLSX.utils.json_to_sheet(formattedData);
// //     const workbook = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
// //     XLSX.writeFile(workbook, "Projects.xlsx");
// //   };
 
//   const exportToPDF = () => {
//     const doc = new jsPDF();
 
//     const tableColumn = [
//       "Sr. No.",
//       "Project Title",
//       "Student Name",
//       "Institution",
//       "Project Type",
//       "AI Score",
//       "Idea File",
//       "PPT File",
//       "Video File",
//       "QR Code",
//     ];
 
//     const tableRows = data.map((item, index) => [
//       index + 1,
//       item.title,
//       item.studentDetails.full_name || "N/A",
//       item.studentDetails.institution || "N/A",
//       item.projectType,
//       item.aiScore,
//       item.idea
//         ? { content: "View File", link: item.idea }
//         : "No File",
//       item.ppt
//         ? { content: "View File", link: item.ppt }
//         : "No File",
//       item.video_file
//         ? { content: "Watch Video", link: item.video_file }
//         : "No File",
//       item.qrCode
//         ? { content: "View QR Code", link: `data:image/png;base64,${item.qrCode}` }
//         : "No QR Code",
//     ]);
 
//     doc.autoTable({
//       head: [tableColumn],
//       body: tableRows,
//       didDrawCell: (data) => {
//         if (data.cell.raw && data.cell.raw.link) {
//           doc.textWithLink(data.cell.raw.content, data.cell.x, data.cell.y, {
//             url: data.cell.raw.link,
//           });
//         }
//       },
//     });
 
//     doc.save("Projects.pdf");
//   };
 
 
//   return (
//     <Box
//       sx={{
//         p: 4,
//         background: "linear-gradient(135deg, #E8F5E9, #E3F2FD)",
//         minHeight: "100vh",
//       }}
//     >
//       <Card
//         elevation={3}
//         sx={{ mb: 3, borderRadius: 4, backgroundColor: "#FAFAFA", mt: 8 }}
//       >
//         <CardHeader
//           title={
//             <Typography
//               variant="h5"
//               sx={{ fontWeight: "bold", color: "#2C3E50" }}
//             >
//               Projects
//             </Typography>
//           }
//           subheader="View projects submitted by entrepreneurs"
//           sx={{ py: 2, borderBottom: "1px solid #E0E0E0" }}
//         />
//         <CardContent>
//           <Box display="flex" gap={2} mb={2}>
//             <TextField
//               placeholder="Search by Project Title"
//               size="small"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               InputProps={{
//                 startAdornment: (
//                   <SearchIcon sx={{ mr: 1, color: "#2C3E50" }} />
//                 ),
//               }}
//               sx={{
//                 width: "300px",
//                 backgroundColor: "#F5F5F5",
//                 borderRadius: 2,
//               }}
//             />
//             <Button
//               variant="contained"
//               onClick={exportToExcel}
//               sx={{ backgroundColor: "#1976D2", color: "#fff" }}
//             >
//               Export to Excel
//             </Button>
//             <Button
//               variant="contained"
//               onClick={exportToPDF}
//               sx={{ backgroundColor: "#D32F2F", color: "#fff" }}
//             >
//               Export to PDF
//             </Button>
//           </Box>
//         </CardContent>
 
//         <TableContainer>
//           <Table>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: "#B0BEC5" }}>
//                 <StyledTableCell>Sr. No.</StyledTableCell>
//                 <StyledTableCell>Project Title</StyledTableCell>
//                 <StyledTableCell>Student Name</StyledTableCell>
//                 <StyledTableCell>Institution</StyledTableCell>
//                 <StyledTableCell>Project Type</StyledTableCell>
//                 <StyledTableCell>AI Score</StyledTableCell>
//                 <StyledTableCell>QR Code</StyledTableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {paginatedData.map((row, index) => (
//                 <TableRow key={row.id}>
//                   <StyledTableCell>
//                     {(page - 1) * ITEMS_PER_PAGE + index + 1}
//                   </StyledTableCell>
//                   <StyledTableCell>{row.title}</StyledTableCell>
//                   <StyledTableCell>{
//                     row.studentDetails.full_name || "N/A"
//                   }</StyledTableCell>
//                   <StyledTableCell>{
//                     row.studentDetails.institution || "N/A"
//                   }</StyledTableCell>
//                   <StyledTableCell>{row.projectType}</StyledTableCell>
//                   <StyledTableCell>{row.aiScore}</StyledTableCell>
//                   <StyledTableCell>
//                     {row.qrCode ? (
//                       <img
//                         src={`data:image/png;base64,${row.qrCode}`}
//                         alt="QR Code"
//                         style={{ width: "50px", cursor: "pointer" }}
//                         onClick={() => handleDownloadQR(row.qrCode, row.title)}
//                       />
//                     ) : (
//                       "No QR Code"
//                     )}
//                   </StyledTableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
 
//         <Pagination
//           count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
//           page={page}
//           onChange={handleChangePage}
//           sx={{ mt: 3 }}
//         />
//       </Card>
//     </Box>
//   );
// };
 
// export default Review;

import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Card,
  CardContent,
  CardHeader,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import SearchIcon from "@mui/icons-material/Search";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import axios from "axios";
import swal from "sweetalert";
import JSZip from "jszip";
const StyledTableCell = styled(TableCell)({
  padding: "16px",
  fontSize: "0.875rem",
  color: "#4A4A4A",
});

const ITEMS_PER_PAGE = 5;

const Review = () => {
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentIdeaId, setCurrentIdeaId] = useState(null);
  const [message, setMessage] = useState("");
  const [amountRange, setAmountRange] = useState("");

  const fetchParticipants = async () => {
    try {
      swal({
        title: "Loading...",
        text: "Fetching projects, please wait.",
        icon: "info",
        buttons: false,
        closeOnClickOutside: false,
      });

      const response = await axios.get(
        "https://newbackend.elephant-tank.com/api/get_idea_submission/"
      );

      const fetchedData = response.data.map((item) => ({
        id: item.id,
        title: item.title,
        description: item.description,
        projectType: item.project_type || "N/A",
        aiScore: item.ai_score || "N/A",
        submissionDate: item.created_at,
        isSingleSubmission: item.is_single_sub ? "Yes" : "No",
        idea: item.idea || null,
        ppt: item.ppt || null,
        video_file: item.video_file || null,
        qrCode: item.qr_code_details?.[0]?.qr_code || null,
        studentDetails: item.stud_id || {},
      }));

      swal.close();
      setData(fetchedData);
    } catch (error) {
      swal("Error", "Failed to fetch projects. Please try again later.", "error");
      console.error("Error fetching participants:", error);
    }
  };

  useEffect(() => {
    fetchParticipants();
  }, []);

  const handleDownloadQR = (qrCode, title) => {
    const link = document.createElement("a");
    link.href = `data:image/png;base64,${qrCode}`;
    link.download = `${title.replace(/\s+/g, "_")}_QR_Code.png`;
    link.click();
  };

  const openMessageDialog = (ideaId) => {
    setCurrentIdeaId(ideaId);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setMessage("");
    setAmountRange("");
  };

  const handleSubmitMessage = async () => {
    if (!message || !amountRange) {
      swal("Error", "Message and amount range are required.", "error");
      return;
    }

    const payload = {
      investor_id: localStorage.getItem("user_id"),
      idea_id: currentIdeaId,
      message: message,
      amount_range: amountRange,
    };

    try {
      swal({
        title: "Submitting...",
        text: "Please wait while we submit your message.",
        icon: "info",
        buttons: false,
        closeOnClickOutside: false,
      });

      const response = await axios.post(
        "https://elephant-eks.tdtlworld.com/api/show_interest/",
        payload
      );

      if (response.data && response.data.msg) {
        swal("Success", response.data.msg, "success");
      }

      setOpenDialog(false);
      setMessage("");
      setAmountRange("");
      fetchParticipants();
    } catch (error) {
      swal("Error", "You have already shown interest in this project.", "error");
      console.error("Error submitting message:", error);
    }
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const filteredData = data.filter((row) =>
    (row.title || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedData = filteredData.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );
  const exportToExcel = () => {
    const formattedData = data.map((item, index) => ({
      "Sr. No.": index + 1,
      "Project Title": item.title,
      "Student Name": item.studentDetails.full_name || "N/A",
      "Institution": item.studentDetails.institution || "N/A",
      "Project Type": item.projectType,
      "AI Score": item.aiScore,
      "Idea File": item.idea ? "Click to View PDF" : "No File",
      "PPT File": item.ppt ? "Click to View PPT" : "No File",
      "Video File": item.video_file ? "Click to View Video" : "No File",
      "QR Code": item.qrCode ? "Click to View QR Code" : "No QR Code",
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
    XLSX.writeFile(workbook, "Projects.xlsx");
  };
  const handleDownloadAllQR = () => {
    if (!data.some((item) => item.qrCode)) {
      swal("Error", "No QR codes available for download.", "error");
      return;
    }
  
    const zip = new JSZip();
    const qrFolder = zip.folder("QR Codes");
  
    data.forEach((item) => {
      if (item.qrCode) {
        const qrFileName = `${item.title.replace(/\s+/g, "_")}_QR_Code.png`;
        qrFolder.file(qrFileName, item.qrCode, { base64: true });
      }
    });
  
    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, "QR_Codes_Build.zip");
    });
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
  
    const tableColumn = [
      "Sr. No.",
      "Project Title",
      "Student Name",

      
      "Institution",
      "Project Type",
      "AI Score",
      "Idea File",
      "PPT File",
      "Video File",
      "QR Code",
    ];
  
    const tableRows = data.map((item, index) => [
      index + 1,
      item.title,
      item.studentDetails.full_name || "N/A",
      item.studentDetails.institution || "N/A",
      item.projectType,
      item.aiScore,
      item.idea
        ? { content: "View File", link: item.idea }
        : "No File",
      item.ppt
        ? { content: "View File", link: item.ppt }
        : "No File",
      item.video_file
        ? { content: "Watch Video", link: item.video_file }
        : "No File",
      item.qrCode
        ? { content: "View QR Code", link: `data:image/png;base64,${item.qrCode}` }
        : "No QR Code",
    ]);
  
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      didDrawCell: (data) => {
        if (data.cell.raw && data.cell.raw.link) {
          doc.textWithLink(data.cell.raw.content, data.cell.x, data.cell.y, {
            url: data.cell.raw.link,
          });
        }
      },
    });
  
    doc.save("Projects.pdf");
  };
  

  return (
    <Box
      sx={{
        p: 4,
        background: "linear-gradient(135deg, #E8F5E9, #E3F2FD)",
        minHeight: "100vh",
      }}
    >
      <Card
        elevation={3}
        sx={{ mb: 3, borderRadius: 4, backgroundColor: "#FAFAFA", mt: 8 }}
      >
        <CardHeader
          title={
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", color: "#2C3E50" }}
            >
              Projects
            </Typography>
          }
          subheader="View projects submitted by entrepreneurs"
          sx={{ py: 2, borderBottom: "1px solid #E0E0E0" }}
        />
        <CardContent>
          {/* <Box display="flex" gap={2} mb={2}>
            <TextField
              placeholder="Search by Project Title"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <SearchIcon sx={{ mr: 1, color: "#2C3E50" }} />
                ),
              }}
              sx={{
                width: "300px",
                backgroundColor: "#F5F5F5",
                borderRadius: 2,
              }}
            />
            <Button
              variant="contained"
              onClick={exportToExcel}
              sx={{ backgroundColor: "#1976D2", color: "#fff" }}
            >
              Export to Excel
            </Button>
            <Button
              variant="contained"
              onClick={exportToPDF}
              sx={{ backgroundColor: "#D32F2F", color: "#fff" }}
            >
              Export to PDF
            </Button>
          </Box> */}
          <Box display="flex" gap={2} mb={2}>
  <TextField
    placeholder="Search by Project Title"
    size="small"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    InputProps={{
      startAdornment: <SearchIcon sx={{ mr: 1, color: "#2C3E50" }} />,
    }}
    sx={{
      width: "300px",
      backgroundColor: "#F5F5F5",
      borderRadius: 2,
    }}
  />
  <Button
    variant="contained"
    onClick={exportToExcel}
    sx={{ backgroundColor: "#1976D2", color: "#fff" }}
  >
    Export to Excel
  </Button>
  <Button
    variant="contained"
    onClick={exportToPDF}
    sx={{ backgroundColor: "#D32F2F", color: "#fff" }}
  >
    Export to PDF
  </Button>
  <Button
    variant="contained"
    onClick={handleDownloadAllQR}
    sx={{ backgroundColor: "#388E3C", color: "#fff" }}
  >
    Download QR Codes
  </Button>
</Box>

        </CardContent>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#B0BEC5" }}>
                <StyledTableCell>Sr. No.</StyledTableCell>
                <StyledTableCell>Project Title</StyledTableCell>
                <StyledTableCell>Student Name</StyledTableCell>
                <StyledTableCell>Institution</StyledTableCell>
                <StyledTableCell>Project Type</StyledTableCell>
                <StyledTableCell>AI Score</StyledTableCell>
                <StyledTableCell>QR Code</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, index) => (
                <TableRow key={row.id}>
                  <StyledTableCell>
                    {(page - 1) * ITEMS_PER_PAGE + index + 1}
                  </StyledTableCell>
                  <StyledTableCell>{row.title}</StyledTableCell>
                  <StyledTableCell>{
                    row.studentDetails.full_name || "N/A"
                  }</StyledTableCell>
                  <StyledTableCell>{
                    row.studentDetails.institution || "N/A"
                  }</StyledTableCell>
                  <StyledTableCell>{row.projectType}</StyledTableCell>
                  <StyledTableCell>{row.aiScore}</StyledTableCell>
                  <StyledTableCell>
                    {row.qrCode ? (
                      <img
                        src={`data:image/png;base64,${row.qrCode}`}
                        alt="QR Code"
                        style={{ width: "50px", cursor: "pointer" }}
                        onClick={() => handleDownloadQR(row.qrCode, row.title)}
                      />
                    ) : (
                      "No QR Code"
                    )}
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
          page={page}
          onChange={handleChangePage}
          sx={{ mt: 3 }}
        />
      </Card>
    </Box>
  );
};

export default Review;